// @flow

import type { Node } from "react";
import GoogleMapReact from "google-map-react";
import styled from "styled-components";
import { media } from "@nested/brand";
import { getConfig } from "@nested/config";

const { GOOGLE_API_KEY } = getConfig();

const createMapOptions = (maps) => ({
  mapTypeId: maps.MapTypeId.ROADMAP,
  disableDefaultUI: false,
  gestureHandling: "cooperative",
  streetViewControl: true,
  styles: [
    {
      featureType: "road",
      elementType: "geometry",
      stylers: [{ color: "white" }],
    },
    {
      featureType: "road",
      elementType: "labels",
      stylers: [{ visibility: "on" }],
    },
  ],
});

// Background color is a specific colour which is shown by google map while the map is not yet loaded
const GoogleMapContainer = styled.div`
  height: 390px;
  margin: 0 0 50px;
  background-color: #e4e3df;

  ${media.tablet`
    height: 400px;
  `};

  ${media.desktop`
    width: calc(3 / 2 * 390px);
  `}
`;

type Props = {
  center: Coordinates,
  children?: Node[] | Node,
};

function MapComponent({ center, children }: Props) {
  return (
    <GoogleMapContainer className="chromatic-ignore">
      <GoogleMapReact
        bootstrapURLKeys={{ key: GOOGLE_API_KEY }}
        defaultCenter={center}
        defaultZoom={16}
        options={createMapOptions}
      >
        {children}
      </GoogleMapReact>
    </GoogleMapContainer>
  );
}

export { MapComponent };
